<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="grid formgrid p-fluid">
    <!-- Generate form fields dynamically based on a configuration object or using *ngFor if applicable -->

    <ng-container *ngFor="let field of formFields">
      <ng-container
        *ngIf="field.rendered != true; else rendered"
      ></ng-container>
      <ng-template #rendered>
        <div class="field mb-2 col-12 md:col-6">
          <!-- label -->
          <ng-container
            *ngIf="
              field.type !== 'checkbox' && field.controlType !== 'checkbox'
            "
          >
            <label [for]="field.name" class="font-medium text-900">{{
              field.label
            }}</label>
          </ng-container>

          <div
            class="field-checkbox w-full h-full"
            *ngIf="
              field.type === 'checkbox' || field.controlType === 'checkbox'
            "
          >
            <div>
              <p-checkbox
                [id]="field.name"
                [formControlName]="field.name"
                [binary]="true"
                [value]="field.value"
                [label]="field.label"
                class="white-space-nowrap"
              ></p-checkbox>
            </div>
            <div *ngIf="field.description" class="mt-1" style="display: block">
              <small id="{{ field.name }}-help" class="text-500">
                {{ field.description }}
              </small>
            </div>
          </div>

          <!-- todo: description -->

          <!-- fields
             ====== 
        controlType - inputType     
        -->

          <!-- text - text -->

          <input
            pInputText
            *ngIf="
              field.type === 'text' ||
              (field.controlType === 'text' && field.inputType === 'text')
            "
            id="{{ field.name }}"
            [formControlName]="field.name"
            [attr.placeholder]="field.placeholder"
            value="{{ field.value }}"
            (blur)="f[field.name]!.markAsDirty()"
          />

          <!-- text - email -->

          <input
            *ngIf="
              field.type === 'email' ||
              (field.inputType === 'email' && field.controlType === 'text')
            "
            type="email"
            id="{{ field.name }}"
            pInputText
            [formControlName]="field.name"
            pKeyFilter="email"
            (blur)="f[field.name]!.markAsDirty()"
          />

          <!-- todo: text - tel -->

          <input
            *ngIf="
              field.type === 'tel' ||
              (field.inputType === 'tel' && field.controlType === 'text')
            "
            pInputText
            type="text"
            id="{{ field.name }}"
            [formControlName]="field.name"
            [pattern]="field.validators?.['pattern']?.pattern ?? ''"
            (blur)="f[field.name]!.markAsDirty()"
          />

          <!--  -->
          <p-calendar
            [id]="field.name"
            *ngIf="
              field.type === 'date' ||
              (field.controlType === 'date' && field.inputType === 'date')
            "
            [showIcon]="true"
            [formControlName]="field.name"
            [showTime]="false"
            dateFormat="yy-mm-dd"
            dataType="string"
            appendTo="body"
            (onBlur)="f[field.name]!.markAsDirty()"
          ></p-calendar>

          <!-- select -->
          <p-dropdown
            *ngIf="field.type === 'select' || field.controlType === 'select'"
            [id]="field.name"
            [options]="field.valueOptions || []"
            optionLabel="label"
            optionValue="value"
            [placeholder]="field.placeholder || 'Select ' + field.label"
            [formControlName]="field.name"
            [filter]="false"
            [showClear]="true"
            appendTo="body"
            (onBlur)="f[field.name]!.markAsDirty()"
          >
            <ng-template pTemplate="filter" let-options="options">
              <div class="flex gap-1">
                <div class="p-inputgroup" (click)="$event.stopPropagation()">
                  <span class="p-inputgroup-addon"
                    ><i class="pi pi-search"></i
                  ></span>
                  <input pInputText placeholder="Search" type="text" />
                </div>
              </div>
            </ng-template>
          </p-dropdown>

          <div *ngIf="field.type === 'radio' || field.controlType === 'radio'">
            <div *ngFor="let option of field.valueOptions" class="mb-3">
              <p-radioButton
                [inputId]="field.name + option.value"
                [value]="option.value"
                [formControlName]="field.name"
              ></p-radioButton>
              <label [for]="field.name + option.value" class="ml-2">{{
                option.label
              }}</label>
            </div>
          </div>

          <!-- File Upload -->

          <p-fileUpload
            mode="advanced"
            [showUploadButton]="false"
            *ngIf="field.type === 'file' || field.controlType === 'file'"
            [id]="field.name"
            [name]="field.name"
            [auto]="true"
            accept=".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/*"
            [maxFileSize]="200000000"
            (onSelect)="onFileSelect($event)"
          >
          </p-fileUpload>

          <!-- multiselect -->

          <p-multiSelect
            [id]="field.name"
            *ngIf="field.type === 'multiselect' || field.type === 'multiselect'"
            [options]="field.valueOptions || []"
            [showClear]="true"
            [filter]="false"
            [formControlName]="field.name"
            optionLabel="label"
            optionValue="value"
            display="chip"
            placeholder="Select {{ field.label }}"
            appendTo="body"
          >
          </p-multiSelect>

          <textarea
            *ngIf="field.type === 'textarea'"
            [id]="field.name"
            formControlName="{{ field.name }}"
            pInputTextarea
            rows="3"
            (blur)="f[field.name].markAsDirty()"
          ></textarea>

          <!-- password -->
          <input
            *ngIf="field.type === 'password'"
            pInputText
            id="{{ field.name }}"
            [formControlName]="field.name"
            type="password"
            (blur)="f[field.name]!.markAsDirty()"
            [attr.placeholder]="field.placeholder"
          />

          <!-- small description -->

          <div
            *ngIf="
              field.description &&
              field.type !== 'checkbox' &&
              field.controlType !== 'checkbox'
            "
          >
            <small class="mx-2 text-500 m-2">{{ field.description }}</small>
            <!-- help text -->
          </div>

          <!-- errors -->
          <!-- ====== -->

          <!-- field errors -->
          <!-- ------------ -->

          <!-- required -->

          <div
            *ngIf="
              f[field.name]?.hasError('required') &&
              f[field.name].invalid &&
              f[field.name].touched
            "
            class="mt-1"
          >
            <small
              class="p-error fadein animation-duration-1000"
              id="{{ field.name }}-help"
              ><strong>{{ field.label }}</strong> is required</small
            >
          </div>

          <!-- email -->

          <div
            *ngIf="f[field.name]?.hasError('email') && f[field.name].touched"
            class="mt-1"
          >
            <small
              class="p-error fadein animation-duration-1000"
              id="{{ field.name }}-help"
              ><strong>{{ field.label }}</strong> is not a valid email
              address</small
            >
          </div>

          <!-- pattern -->
          <div
            *ngIf="f[field.name]?.errors?.['pattern'] && f[field.name].touched"
            class="p-error fadein animation-duration-1000"
            id="{{ field.name }}-help"
          >
            <small>
              <strong>{{ field.label }}</strong> is not a valid phone
              number</small
            >
          </div>
        </div>
      </ng-template>
    </ng-container>
    <!-- end of form fields -->

    <!-- custom global validator errors -->
    <!-- ------------------------------ -->
    <div
      class="field col-12"
      *ngIf="globalFormValidators && globalFormValidators.length > 0"
    >
      <p-message
        *ngIf="form.hasError('PasswordNoMatch')"
        severity="error"
        class="w-full"
        text="The entered passwords do not match"
      ></p-message>

      <p-message
        *ngIf="
          f['confirm_password']?.value === f['password']?.value &&
          !form.hasError('PasswordNoMatch') &&
          f['confirm_password']?.value != '' &&
          f['password']?.value != ''
        "
        severity="success"
        class="w-full"
        text="The passwords match!"
      ></p-message>
    </div>

    <!-- submission errors -->
    <!-- ----------------- -->
    <div class="field col-12" *ngIf="errorMessages && errorMessages.length > 0">
      <p-messages
        key="shareform"
        [(value)]="errorMessages"
        class="fadeoutup fadeindown animation-duration-1000"
      ></p-messages>
    </div>

    <div class="surface-border border-top-1 opacity-50 mb-1 col-12"></div>
    <div class="field lg:col-12 col-12 lg:mt-4">
      <button
        pButton
        pRipple
        [disabled]="!formSubmitAction.enabled"
        [label]="formSubmitAction.label"
        class="{{ formSubmitAction.styleClass }}"
        icon="{{ formSubmitAction.icon }}"
        type="submit"
        [loading]="loading"
      ></button>
    </div>

    <div
      class="field lg:col-6 col-12 lg:mt-4"
      *ngFor="let action of formActions"
    >
      <button
        pButton
        pRipple
        [disabled]="loading"
        [label]="action.label"
        class="{{ action.styleClass }}"
        icon="pi {{ action.icon }}"
        type="button"
        [loading]="loading"
        (click)="onAction(action.action)"
      ></button>
    </div>
  </div>
</form>
